'use strict';

import React from 'react';
import MdLocalPhone from 'react-icons/lib/md/local-phone';
import MdLocalPrintShop from 'react-icons/lib/md/local-print-shop';
import MdEmail from 'react-icons/lib/md/email';
import GoogleMapReact from 'google-map-react';


const LaborTeamMarker = () => <a href="https://goo.gl/maps/XD9zosFBeeG2"><img style={{width: '48px', height: '48px', transform: 'translate(-50%, -100%)'}} src="/static/images/toctome-mapa.svg" alt=""/></a>;


class Footer extends React.Component {
  static defaultProps = {
      center: {lat: 38.730401, lng: -9.276613},
      zoom: 15
    };

    createMapOptions() {
      return {
        scrollwheel: false,
        styles: [
            {
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#d3d3d3"
                    }
                ]
            },
            {
                "featureType": "transit",
                "stylers": [
                    {
                        "color": "#808080"
                    },
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#b3b3b3"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#ffffff"
                    },
                    {
                        "weight": 1.8
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#d7d7d7"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#ebebeb"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#a7a7a7"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#efefef"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#696969"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#737373"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#d6d6d6"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {},
            {
                "featureType": "poi",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#dadada"
                    }
                ]
            }
        ]
      }
    }

  render() {
    return (
      <section className="footer-component" id="contactos">
        <div className="map">
            <GoogleMapReact
              bootstrapURLKeys={{
                    key: 'AIzaSyC2DaDAs6L6WU3A2peLomMPk_opuToBOPQ',
                    language: 'pt'
                }}
              className="google-map"
              options={this.createMapOptions()}
              style={{
                position: 'absolute',
                top: '0px',
                left: '0px',
                right: '0px',
                bottom: '0px'
              }}
              defaultCenter={this.props.center}
              defaultZoom={this.props.zoom}
            >
              <LaborTeamMarker
                lat={this.props.center.lat}
                lng={this.props.center.lng}
              />
            </GoogleMapReact>
        </div>
        <div className="footer-content">
          <div className="info">
            <div className="location">
              <h4 className="title">Onde Estamos</h4>
              <p>
                Rua João de Araújo Correia<br/>
                Nº2, Loja B, Barcarena
              </p>
              <p>
                2730-246 Barcarena
              </p>
              {/* <a className="link" href="https://goo.gl/maps/XD9zosFBeeG2">
                <img src="/static/images/f+e.svg" />
                <span>Ver no Mapa</span>
              </a> */}
            </div>

            <div className="contacts">
              <h4 className="title">Contactos</h4>
              <p>
                214 239 104<br/>
                214 239 105
              </p>
              <p>
                963 967 986
              </p>
              <p>
                <a href="mailto:geral@toctome.pt">geral@toctome.pt</a>
              </p>
            </div>

            <div className="partners">
              <h4 className="title">Parceiros</h4>
              <a className="link" href="https://laborteam.pt/">
                <img src="/static/images/laborteam.svg" />
                <span>Labor Team</span>
              </a>
              <a className="link" href="http://fpluse.eu/">
                <img src="/static/images/f+e.svg" />
                <span>F+E</span>
              </a>
            </div>
          </div>
          <div className="links">
            <h4 className="title">Links Úteis</h4>
            <a className="link" href="https://www.portaldasfinancas.gov.pt/">
              <img src="/static/images/links/atlogo.svg" />
              <span>AT Serviços Tributários</span>
            </a>
            <a className="link" href="http://www.cnc.min-financas.pt/">
              <img src="/static/images/links/cnclogo.svg" />
              <span>Comissão de Normalização Contabilística</span>
            </a>
            <a className="link" href="http://www.cartasocial.pt/">
              <img src="/static/images/links/geplogo.svg" />
              <span>Gabinete de Estratégia e Planeamento</span>
            </a>
            <a className="link" href="https://www.iapmei.pt/">
              <img src="/static/images/links/iapmeilogo.svg" />
              <span>Instituto de Apoio às Pequenas e Médias Empresas e ao Investimento</span>
            </a>
            <a className="link" href="https://www.ine.pt/">
              <img src="/static/images/links/inelogo.svg" />
              <span>Instituto Nacional de Estatística</span>
            </a>
            <a className="link" href="https://www.occ.pt/pt/">
              <img src="/static/images/links/occlogo.svg" />
              <span>Ordem dos Contabilistas Certificados</span>
            </a>
            <a className="link" href="https://bde.portaldocidadao.pt/CVE/pt/EOL">
              <img src="/static/images/links/eollogo.svg" />
              <span>Portal da Empresa</span>
            </a>
            <a className="link" href="https://bde.portaldocidadao.pt/">
              <img src="/static/images/links/pdclogo.svg" />
              <span>Portal do Cidadão</span>
            </a>
            <a className="link" href="http://www.irn.mj.pt/IRN/sections/irn/a_registral/rnpc/">
              <img src="/static/images/links/irnlogo.svg" />
              <span>Registos Nacional de Pessoas Colectivas</span>
            </a>
            <a className="link" href="http://www.seg-social.pt/inicio">
              <img src="/static/images/links/sslogo.svg" />
              <span>Segurança Social</span>
            </a>
          </div>
        </div>
      </section>
    );
  }
}

Footer.displayName = 'Footer';

// Uncomment properties you need
// Footer.propTypes = {};
// Footer.defaultProps = {};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js